import { apiUrl } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';
import toast, { Toaster } from "react-hot-toast"

export const getQuarters = async (filters = {}) => {
    const token = await UserProfile.getToken();
    const response = await axios.get(`${apiUrl}admin/kpis/quarters`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: filters
    });
    if (response.data == "loading") {
        // toast.loading('Scraper Working');
    }

    else if (!response.data) {
        toast.error('No data exists for this quarter');
    }
    return response.data
};

export const updateBonusPeriod = async (filters = {}, record = {}) => {
    try {
        const token = await UserProfile.getToken();
        const response = await axios.put(
            `${apiUrl}admin/kpis/quarters`,
            record,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: filters, // Query parameters
            }
        );
        toast.success(response.data.message);
    } catch (error) {
        Object.values(error.response.data).forEach((error) => {
            toast.error(error);
        });
    }
}

export const fetchQuartersB085 = async (filters = {}) => {
    const token = await UserProfile.getToken();

    try {
        const response = await axios.post(
            `${apiUrl}admin/kpis/quarters`,
            {},  // Empty body, we are only sending query parameters
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: filters  // `filters` will be sent as query parameters in the URL
            }
        );
        toast.success(response.data.message);
        return response.data;
    }

    catch (error) {
        toast.error(error.response.data.message);
    }
};

export const updateBonusResult = async (filters = {}, record = {}) => {
    try {
        const token = await UserProfile.getToken();
        const response = await axios.put(
            `${apiUrl}admin/kpis/people`,
            record,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: filters, // Query parameters
            }
        );
        toast.success(response.data.message);
    } catch (error) {
        error.response.data?.message? toast.error(error.response.data.message): toast.error(error.response.data)
    }
};

export const updateBonusResultTeam = async (filters = {}, targetTeamID) => {
    try {
        const token = await UserProfile.getToken();
        const response = await axios.put(
            `${apiUrl}admin/kpis/people_per_teams`,
            { teamId: targetTeamID },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: filters, // Query parameters
            }
        );
        toast.success(response.data.message);
        return response.data;
    } catch (error) {
        toast.error('Error updating team');
        console.error(error);
    }
};

export const getKPIBonusPeople = async (filters = {}) => {
    const token = await UserProfile.getToken();
    const response = await axios.get(`${apiUrl}admin/kpis/kpi_people`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: filters,
    });
    return response;
};

export const createKPIBonusPeople = async (filters = {}) => {
    const token = await UserProfile.getToken();
    const response = await axios.post(
        `${apiUrl}admin/kpis/kpi_people`, // API endpoint
        null, // Request body (null if no body is needed)
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: filters, // Query parameters
        }
    );
    return response;
};

export const updateKPIBonusPeople = async (record = {}) => {
    const token = await UserProfile.getToken();
    const response = await axios.put(
        `${apiUrl}admin/kpis/kpi_people`,
        record,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            // params: filters, // Query parameters
        }
    );
    return response;
}

export const deleteKPIBonusPeople = async (record = {}) => {
    const token = await UserProfile.getToken();
    const response = await axios.delete(
        `${apiUrl}admin/kpis/kpi_people`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            data: record
        }
    );
    return response;
}

export const getKPIBonusCalculations = async (filters = {}) => {
    const token = await UserProfile.getToken();
    const response = await axios.get(
        `${apiUrl}admin/kpis/kpi_people/calculate_bonuses`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: filters,
        });
    return response;
}